import { Controller } from "@hotwired/stimulus"

// "Plan a garden with this plant" CTA on plant profiles.
// Copy (and visibility) is controlled by the PostHog experiment flag
// `plant-page-planner-cta`: control = hidden, `plan-garden` / `design-bed`
// pick the copy. Without PostHog (dev, ad blockers) the default copy shows,
// outside the experiment.
export default class extends Controller {
  static values = {
    slug: String,
    plantName: String,
    variant: String,
  }

  static targets = ["label"]

  static FLAG = "plant-page-planner-cta"

  connect() {
    this.decided = false
    if (this.variantValue) {
      // Variant was evaluated server-side and the button rendered directly
      this.decided = true
      this.variant = this.variantValue
    } else if (window.posthog && typeof window.posthog.onFeatureFlags === "function") {
      window.posthog.onFeatureFlags(() => this.applyVariant())
      this.fallbackTimer = setTimeout(() => this.applyVariant(), 3000)
    } else {
      this.show("plan-garden")
    }
  }

  disconnect() {
    clearTimeout(this.fallbackTimer)
  }

  applyVariant() {
    if (this.decided) return
    const variant = window.posthog.getFeatureFlag(this.constructor.FLAG)
    if (variant === "control") {
      this.decided = true
      return
    }
    this.show(variant || "plan-garden")
  }

  show(variant) {
    this.decided = true
    this.variant = variant
    if (variant === "design-bed") {
      this.labelTarget.textContent = `Design a garden bed with ${this.plantNameValue}`
    }
    this.element.hidden = false
  }

  click() {
    window.posthog?.capture("plant_planner_cta_clicked", {
      plant_slug: this.slugValue,
      variant: this.variant,
    })
  }
}
